module.exports = __webpack_public_path__ + "img/Grundwissen_Classic.212cbba0.png";